import * as React from 'react'
import { Card, Descriptions } from 'antd'
import { DepositEdit } from '../../edit/types'

type Props = {
  deposit: DepositEdit
}

export const DepositVendorData = ({ deposit }: Props) => {
  const externalId =
    deposit.externalTransaction?.externalId ||
    deposit.externalPaymentTransaction?.externalId
  const vendor = deposit.externalPaymentTransaction

  if (!externalId && !vendor) return null

  return (
    <Card size="small" title="Vendor data">
      <Descriptions size="small" column={{ xs: 1, sm: 2 }} bordered>
        {externalId && (
          <Descriptions.Item label="External ID" span={2}>
            {externalId}
          </Descriptions.Item>
        )}
        {vendor && (
          <>
            <Descriptions.Item label="Status">
              {vendor.externalStatus}
            </Descriptions.Item>
            <Descriptions.Item label="Initial amount">
              {vendor.initialAmount} {vendor.initialCurrency}
            </Descriptions.Item>
            <Descriptions.Item label="Paid amount">
              {vendor.paidAmount} {vendor.paidCurrency}
            </Descriptions.Item>
            <Descriptions.Item label="Commission">
              {vendor.vendorCommission} {vendor.vendorCommissionCurrency}
            </Descriptions.Item>
          </>
        )}
      </Descriptions>
    </Card>
  )
}
